class GoogleObserver {
  observerConfig = {
    attributes: true,
    childList: true,
    subtree: true,
  };

  listeningTo = [];

  observer = null;

  googleContentLoading = false;

  paused = true;

  resultsLoading = false;

  observedElement = null;

  watchFor(elementToWatch, callback, configOverride) {
    this.reset();
    this.unpause();
    this.observedElement = elementToWatch;
    const config = configOverride || this.observerConfig;

    return new Promise((resolve, reject) => {
      this.observer = new MutationObserver((mutations) => {
        try {
          const desiredResult = callback(mutations) || false;

          if (desiredResult) {
            this.reset();
            resolve(desiredResult);
          }
        } catch (error) {
          this.reset();
          reject(error);
        }
      });

      this.observer.observe(elementToWatch, config);
    });
  }

  listenTo(element, callback, config) {
    if (this.isListeningTo(element)) {
      return;
    }

    const observer = new MutationObserver((mutations, observerInstance) => {
      callback(mutations, observerInstance);
    });

    observer.observe(element, config);

    this.listeningTo.push(element);
  }

  isListeningTo(element) {
    return this.listeningTo.includes(element);
  }

  reset() {
    if (!this.observer) {
      return;
    }

    this.observer.disconnect();
    this.pause();
  }

  pause() {
    this.paused = true;

    return this;
  }

  unpause() {
    this.paused = false;

    return this;
  }

  disconnect() {
    this.observer.disconnect();

    return this;
  }
}

export default GoogleObserver;
